import { render, staticRenderFns } from "./ViewSalesInvoicePage.vue?vue&type=template&id=8423ff28"
import script from "./ViewSalesInvoicePage.vue?vue&type=script&lang=js"
export * from "./ViewSalesInvoicePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports